import Routers from './Route';
import AnimationThemeProvider from './_helper/AnimationTheme/AnimationThemeProvider';
import ChartistProvider from './_helper/Chartist/ChartistProvider';
import CustomizerProvider from './_helper/Customizer/CustomizerProvider';
import GoogleChartProvider from './_helper/GoogleChart/GoogleChartProvider';
import ChartjsProvider from './_helper/Chartjs/ChartProvider';
import TableProvider from './_helper/Table/TableProvider';
import ProjectProvider from './_helper/Project/ProjectProvider';
import ChatProvider from './_helper/Chat/ChatProvider';
import EmailProvider from './_helper/Email/EmailProvider';
import WishListProvider from './_helper/Ecommerce/Wishlist/WishlistProvider';
import ProductProvider from './_helper/Ecommerce/Product/ProductProvider';
import FilterProvider from './_helper/Ecommerce/Filter/FilterProvider';
import CartProvider from './_helper/Ecommerce/Cart/CartProvider';
import ContactProvider from './_helper/Contact/ContactProvider';
import KanbanProvider from './_helper/Kanban/KanbanProvider';
import BookmarkProvider from './_helper/Bookmark/BookmarkProvider';
import TaskProvider from './_helper/Task/TaskProvider';
import TodoProvider from './_helper/Todo/TodoProvider';
import SearchResultProvider from './_helper/SearchResult/SearchResult';
import GalleryProvider from './_helper/Gallery/GalleryProvider';
import JobSearchProvider from './_helper/JobSearch/JobSearchProvider';
import LearningProvider from './_helper/Learning/LearningProvider';
import FaqProvider from './_helper/Faq/FaqProvider';
import { toast, ToastContainer } from 'react-toastify';
import { useEffect } from 'react';
import { getFirebaseMessaging } from './Firebase/FireBase';
import { onMessage } from 'firebase/messaging';
import { useDispatch, useSelector } from 'react-redux';
import { addNotification, setNotificationCount } from './Redux/NotificationReducer';
import { getNotificationCount, getNotificationCountRole } from './CommonUrl';
import { getClientUrlDataToken } from './Utils/restUtils';

const App = () => {
  const dispatch = useDispatch()
  const authState = useSelector((state) => state.auth);

  useEffect(() => {
    let unsubscribe;

    const initFCM = async () => {
      const messaging = await getFirebaseMessaging();
      if (!messaging) return;

      unsubscribe = onMessage(messaging, (payload) => {
        if (payload?.notification) {
          toast(
            <div className="p-2 text-start">
              <div className="fw-bold mb-1">
                📩 {payload.notification?.title || 'Notification'}
              </div>
              <div className="mb-2">{payload.notification?.body}</div>
            </div>,
            {
              className: "bg-primary text-white rounded",
              progressClassName: "bg-white!",
              autoClose: 5000,
              position: "top-right",
              closeButton: true,
              progressStyle: {
                background: "white"
              }
            }
          );
          dispatch(addNotification(payload?.notification))
          notificationCount()
        }
      });
    };

    initFCM();
    return () => unsubscribe && unsubscribe();
  }, []);


  const notificationCount = async () => {
    const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getNotificationCount :
      getNotificationCountRole)
    dispatch(setNotificationCount(response?.data))

  };
  return (
    <>
      <AnimationThemeProvider>
        <CustomizerProvider>
          <GoogleChartProvider>
            <ChartistProvider>
              <ChartjsProvider>
                <TableProvider>
                  <ProjectProvider>
                    <ChatProvider>
                      <EmailProvider>
                        <CartProvider>
                          <FilterProvider>
                            <ProductProvider>
                              <WishListProvider>
                                <ContactProvider>
                                  <KanbanProvider>
                                    <BookmarkProvider>
                                      <TaskProvider>
                                        <TodoProvider>
                                          <SearchResultProvider>
                                            <GalleryProvider>
                                              <JobSearchProvider>
                                                <LearningProvider>
                                                  <FaqProvider>
                                                    <Routers />
                                                  </FaqProvider>
                                                </LearningProvider>
                                              </JobSearchProvider>
                                            </GalleryProvider>
                                          </SearchResultProvider>
                                        </TodoProvider>
                                      </TaskProvider>
                                    </BookmarkProvider>
                                  </KanbanProvider>
                                </ContactProvider >
                              </WishListProvider >
                            </ProductProvider >
                          </FilterProvider >
                        </CartProvider >
                      </EmailProvider >
                    </ChatProvider >
                  </ProjectProvider >
                </TableProvider >
              </ChartjsProvider >
            </ChartistProvider >
          </GoogleChartProvider >
        </CustomizerProvider >
      </AnimationThemeProvider >
      <ToastContainer />
    </>
  )
}
  ;

export default App;
